import axios from 'axios';
import { API_CONFIG } from '../config';
import { getStoredToken, clearStored } from '../utils/authStorage';

const axiosInstance = axios.create({
  baseURL: API_CONFIG.baseURL,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token && !config.url?.includes('/auth/google')) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = err.config?.url ?? '';
      if (!path.includes('/api/auth/') && !path.includes('/api/v2/auth/')) {
        clearStored();
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent('auth:logout'));
        }
      }
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
